<script>
import { onMount, onDestroy } from 'svelte';
import axios from 'axios';

let data = [];
let intervalId;

// 添加區域名稱映射
const areaNameMap = {
  AIRPORT: '機場',
  CENTRAL: '中環',
  LANGHAM_PLACE: '朗豪坊',
  // 可以根據需要添加更多映射
};

async function fetchData() {
  try {
    const response = await axios.get('https://uber-api.johnkhw.work/api/data');
    data = response.data;
  } catch (error) {
    console.error('獲取數據時出錯:', error);
  }
}

// 添加一個輔助函數來獲取中文名稱
function getChineseName(englishName) {
  return areaNameMap[englishName] || englishName;
}

onMount(() => {
  fetchData(); // 初始加載
  intervalId = setInterval(fetchData, 10000); // 每10秒重新獲取一次數據
});

onDestroy(() => {
  if (intervalId) {
    clearInterval(intervalId); // 清除定時器以防止記憶體洩漏
  }
});
</script>

<main>
  <h1>區域價格倍數表</h1>
  {#if data.length > 0}
    <table>
      <thead>
        <tr>
          <th>區域</th>
          <th>X/C/T</th>
          <th>B/XL</th>
        </tr>
      </thead>
      <tbody>
        {#each data as item}
          <tr>
            <td>{getChineseName(item.name)}</td>
            {#each item.result as service}
              <td>{service.multiplier}</td>
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
  {:else}
    <p>載入中...</p>
  {/if}
</main>

<style>
  table {
    border-collapse: collapse;
    width: 100%;
  }
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
  }
</style>